/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import * as React from 'react';
import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';
// import { NumericFormat } from 'react-number-format';

const QuantityNumberField = React.forwardRef(function TextMaskCustom(props, ref) {
  const { name, onChange, ...other } = props;
  const onAcceptValue = (value) => {
    const intValue = parseInt(value, 10); // specify the radix
    const newValue = Number.isNaN(intValue) ? '' : Math.max(1, intValue);
    onChange({ target: { name, value: newValue.toString() } });
  };

  return (
    <IMaskInput
      {...other}
      mask="00000000"
      definitions={{ '#': /[0-9]/ }}
      inputRef={ref}
      onAccept={(value) => onAcceptValue(value)}
      overwrite
    />
  );
});

QuantityNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default QuantityNumberField;
